var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPennsylvania(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.855,155.201c0-2.475-5.523-4.596-5.523-4.596s-10.392-9.903-13.574-12.025c-3.184-2.122-1.061-8.134,1.416-10.256 c2.476-2.122-1.77-6.719-1.77-8.841c0-2.122,5.658-9.903,5.658-9.903l-1.439-6.365l4.977-3.89l-3.184-3.89 c0,0-5.658,0.708-10.607-5.658c-0.039-0.05-0.074-0.097-0.112-0.146c-4.851-6.279-5.923-10.112-8.731-10.463 c-2.828-0.355-6.365-4.244-6.365-4.244L60.134,103.569l-2.078-12.731L35.071,109.58l10.253,62.951l7.516,41.287l35.808-4.774 c39.607-7.338,131.027-26.081,131.027-26.081c0.102,0.232,0.203,0.471,0.307,0.714l6.766-7.257l5.307,0.708 c0,0,9.547-4.243,8.839-5.304S251.855,157.678,251.855,155.201z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennsylvania);
export default __webpack_public_path__ + "static/media/pennsylvania.462854cacbf22cb672e9715c06133822.svg";
export { ForwardRef as ReactComponent };